import React from "react"
import MapboxHelpTooltip from './MapboxHelpTooltip.jsx'

const CoordinateInput = ({value, base_name, title, defaultCenter, updateField, description}) => {
    const lat_name = `${base_name}.lat`
    const lng_name = `${base_name}.lng`
    return (
        <>
            <label className="col-xs-12 col-md-12">
                {title}
                <MapboxHelpTooltip description={description} />
            </label>
            <label className="col-xs-6 col-md-6">
            {I18n.t("lat")}
            <input
                type="number"
                className="form-control"
                name={lat_name}
                step="any"
                value={(value || {}).lat || (defaultCenter != null ? defaultCenter[0] : "")}
                onChange={(e) => updateField(lat_name, e.target.value)}
            />
            </label>
            <label className="col-xs-6 col-md-6">
            {I18n.t("lng")}
            <input
                type="number"
                className="form-control"
                name={lng_name}
                step="any"
                value={(value || {}).lng || (defaultCenter != null ? defaultCenter[1] : "")}
                onChange={(e) => updateField(lng_name, e.target.value)}
            />
            </label>
        </>
    )
}

export default CoordinateInput